import { NgAisModule } from 'angular-instantsearch';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FomanticUIModule } from 'ngx-fomantic-ui';
import { NgxPaginationModule } from 'ngx-pagination';
import { SwiperModule } from 'ngx-swiper-wrapper';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { ListingRoutingModule } from './listing-routing.module';
import { UiModule } from '@monorepo/ui';

import { ListingContainerComponent } from './components/listing-container/listing-container.component';
import { ScreenListingItemModule } from '../screen-listing-item/screen-listing-item.module';
import { FacetContainerComponent } from './components/facet-container/facet-container.component';
import { MapViewComponent } from './components/map-view/map-view.component';
import { CardViewComponent } from './components/card-view/card-view.component';
@NgModule({
  declarations: [
    ListingContainerComponent,
    FacetContainerComponent,
    MapViewComponent,
    CardViewComponent,
  ],
  imports: [
    CommonModule,
    ListingRoutingModule,
    FomanticUIModule,
    FormsModule,
    UiModule,
    NgAisModule,
    ReactiveFormsModule,
    NgxPaginationModule,
    MatExpansionModule,
    SwiperModule,
    MatCheckboxModule,
    ScreenListingItemModule,
  ],
})
export class ListingModule {}
